import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon, DollarSignIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { mockRD } from '../data/mockData';
import { CartItem } from '../types';
interface ProfileProps {
  cart: CartItem[];
  onNavigateBack: () => void;
  onNavigateToCart: () => void;
}
export function Profile({
  cart,
  onNavigateBack,
  onNavigateToCart
}: ProfileProps) {
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  return <div className="min-h-screen bg-gray-50" data-id="element-254">
      <Header cartCount={cartCount} onCartClick={onNavigateToCart} onProfileClick={() => {}} data-id="element-255" />

      <div className="max-w-lg mx-auto px-4 py-6" data-id="element-256">
        <button onClick={onNavigateBack} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors" data-id="element-257">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-258" />
          <span className="font-medium" data-id="element-259">Back</span>
        </button>

        <div className="text-center mb-6" data-id="element-260">
          <img src={mockRD.avatar} alt={mockRD.name} className="w-24 h-24 rounded-full object-cover border-4 border-green-400 mx-auto mb-3" data-id="element-261" />
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-262">{mockRD.name}</h1>
          <p className="text-gray-600" data-id="element-263">{mockRD.credentials}</p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-264">
            Your Registered Dietitian
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6" data-id="element-265">
          <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-266">
            Your Nutrition Plan
          </h2>

          <div className="space-y-3" data-id="element-267">
            {mockRD.planSummary.map((item, index) => <div key={index} className="flex gap-3" data-id="element-268">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-269" />
                <p className="text-gray-700 text-sm leading-relaxed" data-id="element-270">{item}</p>
              </div>)}
          </div>
        </div>

        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl shadow-lg p-6 text-white mb-6" data-id="element-271">
          <div className="flex items-center gap-3 mb-4" data-id="element-272">
            <div className="bg-white/20 rounded-full p-2" data-id="element-273">
              <DollarSignIcon className="w-6 h-6" data-id="element-274" />
            </div>
            <h2 className="text-lg font-bold" data-id="element-275">Weekly Stipend: $200</h2>
          </div>
          <div className="space-y-2 text-sm text-green-50" data-id="element-276">
            <p data-id="element-277">
              • Your healthcare plan covers $200/week for plan-approved
              groceries
            </p>
            <p data-id="element-278">• The $200 includes the cost of items AND tax on those items</p>
            <p data-id="element-279">
              • Lola's 5% service fee is paid by your healthcare plan (not you)
            </p>
            <p data-id="element-280">• You only pay for extra items and their tax</p>
            <p data-id="element-281">• Your RD reviews all covered items to keep you on track</p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-2xl shadow-lg p-6 text-white mb-6" data-id="element-282">
          <h2 className="text-lg font-bold mb-2" data-id="element-283">How It Works</h2>
          <div className="space-y-2 text-sm text-purple-50" data-id="element-284">
            <p data-id="element-285">• Shop with real-time guidance from your RD</p>
            <p data-id="element-286">• Plan-approved items automatically go to "Covered" section</p>
            <p data-id="element-287">• Items are covered until you reach $200 (including tax)</p>
            <p data-id="element-288">• Extra items and items over $200 are paid by you</p>
            <p data-id="element-289">
              • Your healthcare plan pays for covered items, tax, and Lola's fee
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6" data-id="element-290">
          <h2 className="text-lg font-bold text-gray-900 mb-3" data-id="element-291">
            Contact Your RD
          </h2>
          <p className="text-sm text-gray-600 mb-4" data-id="element-292">
            Have questions about your plan or specific foods? Reach out anytime.
          </p>
          <button className="w-full bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-4 rounded-full transition-colors" data-id="element-293">
            Send Message
          </button>
        </div>
      </div>
    </div>;
}